export const Routes = {
	CUSTOMIZE_DEAL: { path: '/', name: 'customizeDeal' },
	DEAL_DETAILS: { path: '/deal-details', name: 'dealDetails' },
	TRADE_IN: { path: '/trade-in', name: 'tradeIn' },
	TRADE_IN_CONDITION: { path: '/trade-in/condition', name: 'tradeInCondition' },
	TRADE_IN_OVERVIEW: { path: '/trade-in/overview', name: 'tradeInOverview' },
	ERROR: { path: '/error', name: 'error' },
	BLANK: { path: '/blank', name: 'blank' },
	OPTIONS: { path: '/options', name: 'options' },
	OPTION_DETAILS: { path: '/option-details/:id/:type', name: 'optionDetails' },
	DEV: { path: '/dev', name: 'dev' },
	SAVE_MY_DEAL_FORM: { path: '/save-my-deal/form', name: 'saveMyDealForm' },
	SAVE_MY_DEAL_SUCCESS: { path: '/save-my-deal/success', name: 'saveMyDealSuccess' },
	REBATES_SETTINGS: { path: '/rebates/settings', name: 'rebatesSettings' },
	REBATES: { path: '/rebates', name: 'rebates' },
	REBATES_DETAILS: { path: '/rebates/settings/:id', name: 'rebatesDetails' },
	ZIPCODE: { path: '/zipcode', name: 'zipcode' },
	DEAL_PROGRESS: { path: '/dealProgress', name: 'DealProgress' },
	RESERVE_VEHICLE_OVERVIEW: { path: '/reserve-vehicle-overview', name: 'reserveVehicleOverview' },
	RESERVED_VEHICLE_INFO: { path: '/reserved-vehicle-info', name: 'reservedVehicleInfo' },
	RESERVE_VEHICLE_FORM: { path: '/reserve-vehicle-form', name: 'reserveVehicleForm' },
	RESERVE_VEHICLE_PAYMENT_RESPONSE: { path: '/reserve-vehicle-payment-response', name: 'reserveVehiclePaymentResponse' },
	SCHEDULE_TEST_DRIVE: { path: '/schedule-test-drive', name: 'scheduleTestDrive' },
	SCHEDULE_TEST_DRIVE_CONTACT: { path: '/schedule-test-drive/contact', name: 'scheduleTestDriveContact' },
	SCHEDULE_TEST_DRIVE_SUCCESS: { path: '/schedule-test-drive/success', name: 'scheduleTestDriveSuccess' },
	CREDIT_SCORE: { path: '/credit-score', name: 'creditScore' },
	CREDIT_SCORE_SUCCESS: { path: '/credit-score-success', name: 'creditScoreSuccess' },
	CREDIT_APPLICATION: { path: '/credit-application', name: 'creditApplication' },
	CREDIT_APPLICATION_SUCCESS: { path: '/credit-application-success', name: 'creditApplicationSuccess' },
	ACCESSORIES: { path: '/accessories', name: 'accessories' },
	ACCESSORIES_DETAILS: { path: '/accessory-detail/:id', name: 'accessoriesDetails' },
	CONTACT_US: { path: '/contact-us', name: 'contactUs' },
	DEALER_DISCOUNT_FORM: { path: '/dealer-discount/form', name: 'dealerDiscountForm' },
	DEALER_DISCOUNT_SUCCESS: { path: '/dealer-discount/success', name: 'dealerDiscountSuccess' },
};
